














import { Component, Vue } from 'vue-property-decorator'
import NavBar from './components/NavBar.vue'
import PageFooter from './components/PageFooter.vue'
import SingleProduct from './components/SingleProduct.vue'

import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)

@Component({
    components: {
        NavBar,
        PageFooter,
        SingleProduct
    }
})
export default class App extends Vue {}
